/* <lt-frame-format> — the Art Print / Canvas switch above the option rows,
   and the memory of the visitor's choices between products
   (snippets/product-variant-picker.liquid, docs/variant-picker-drawer.md,
   "Format i pamięć wyboru").

   The switch is two pill buttons inside <variant-picker>, so it comes back
   with every server render of the picker; it keeps no state of its own. A
   click checks a Frame radio of the other format (and the passe-partout
   radio that goes with it) and replays `change` from it: the frame preview
   redraws on that event (assets/lt-frame-preview.js) and product-info-bento.js
   fetches the variant, exactly as after a choice in the frame drawer. Canvas
   takes the canvas frame chosen last in this visit, else the first available
   one; Art Print the last art print frame and passe-partout, else Unframed.

   The memory lives in sessionStorage (owner, 2026-10-16: this visit only):
   the size by its label, the format, the last frame of each format by its
   key (snippets/lt-frame-info.liquid) and the passe-partout by position. It is
   applied once on load, unless the URL names a variant (`?variant=`, the
   links of ads and Merchant Center win), and only to radios the visitor's
   country may buy: `[data-frame-state]` says which formats are sold here,
   and a value marked unavailable is never checked. */
(function () {
  if (customElements.get('lt-frame-format')) return;

  var KEY = 'lt-option-memory';

  function readMemory() {
    try {
      return JSON.parse(window.sessionStorage.getItem(KEY)) || {};
    } catch (error) {
      return {};
    }
  }

  function writeMemory(memory) {
    try {
      window.sessionStorage.setItem(KEY, JSON.stringify(memory));
    } catch (error) {
      // Storage blocked (private mode, settings): the page works without it.
    }
  }

  function frameState(picker) {
    var node = picker && picker.querySelector('[data-frame-state]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  /* A radio group of the picker by name. Trimmed: product-variant-options
     renders the name with a trailing newline. */
  function group(picker, name) {
    if (!name) return [];
    return Array.prototype.filter.call(picker.querySelectorAll('input[type="radio"]'), function (radio) {
      return radio.name.trim() === name;
    });
  }

  function checkedIn(radios) {
    for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i];
    return null;
  }

  function usable(radio) {
    return !!radio && !radio.classList.contains('disabled');
  }

  function material(radio) {
    return (radio && radio.dataset.frameMaterial) || 'none';
  }

  /* The Frame and passe-partout radios that make `format` with the memory:
     [frame, mat]. Null when the format has nothing to offer. */
  function formatRadios(picker, state, format, memory) {
    var frames = group(picker, state.frameInput);
    var mats = group(picker, state.matInput);
    var frame = null;

    if (format === 'canvas') {
      if (!state.canvas) return null;
      var canvases = frames.filter(function (radio) {
        return material(radio) === 'canvas' && usable(radio);
      });
      frame =
        canvases.filter(function (radio) { return radio.dataset.frameKey === memory.canvas; })[0] ||
        canvases[0] ||
        null;
    } else {
      if (state.wood && memory.print) {
        frame = frames.filter(function (radio) {
          return radio.dataset.frameKey === memory.print && material(radio) !== 'canvas' && usable(radio);
        })[0];
      }
      if (!frame) {
        frame = frames.filter(function (radio) { return material(radio) === 'none'; })[0] || null;
      }
    }
    if (!frame) return null;

    // No availability test here: Shopify marks a passe-partout value in the
    // context of the frame selected NOW (White is "unavailable" under a
    // canvas), not of the frame about to be checked.
    var mat = mats[0] || null;
    if (material(frame) === 'wood' && state.mats && mats[memory.mat]) mat = mats[memory.mat];
    return [frame, mat];
  }

  /* Checks the radios and replays `change` from one that changed (the frame
     radio first: its drawer resets the passe-partout for canvas). */
  function commit(radios) {
    radios = radios.filter(Boolean);
    var changed = radios.filter(function (radio) { return !radio.checked; });
    if (!changed.length) return false;
    radios.forEach(function (radio) { radio.checked = true; });
    changed[0].dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function remember(picker) {
    var state = frameState(picker);
    if (!state) return;
    var memory = readMemory();

    var size = checkedIn(group(picker, state.sizeInput));
    if (size) memory.size = size.value;

    var frame = checkedIn(group(picker, state.frameInput));
    if (frame) {
      var kind = material(frame);
      if (kind === 'canvas' && state.canvas) {
        memory.format = 'canvas';
        memory.canvas = frame.dataset.frameKey;
      } else if (kind !== 'canvas' && (state.wood || state.canvas)) {
        memory.format = 'print';
        if (state.wood) memory.print = frame.dataset.frameKey || 'unframed';
        var mats = group(picker, state.matInput);
        var mat = checkedIn(mats);
        if (kind === 'wood' && state.mats && mat) memory.mat = mats.indexOf(mat);
      }
    }
    writeMemory(memory);
  }

  function restore(picker) {
    var state = frameState(picker);
    if (!state) return;
    var memory = readMemory();
    var radios = [];

    if (memory.size) {
      radios.push(
        group(picker, state.sizeInput).filter(function (radio) {
          return radio.value === memory.size && usable(radio);
        })[0]
      );
    }
    if (memory.format && state.frameInput) {
      var format = memory.format === 'canvas' && state.canvas ? 'canvas' : 'print';
      var pair = formatRadios(picker, state, format, memory);
      // The frame first, so the change is replayed from its drawer.
      if (pair) radios = pair.concat(radios);
    }
    commit(radios);
  }

  function pickers() {
    return document.querySelectorAll('variant-picker');
  }

  /* Every choice is remembered once the radios hold it: the option drawer
     moves itself home and resets the passe-partout synchronously, so a task
     later the picker's radios are final (as in lt-frame-preview.js). */
  document.addEventListener(
    'change',
    function (event) {
      var input = event.target;
      if (!input || input.type !== 'radio' || !input.name) return;
      setTimeout(function () {
        Array.prototype.forEach.call(pickers(), remember);
      }, 0);
    },
    true
  );

  /* Once, when the page can answer the change (product-info-bento.js is a
     deferred script of its own). */
  if (!new URLSearchParams(window.location.search).has('variant')) {
    customElements.whenDefined('product-info').then(function () {
      Array.prototype.forEach.call(pickers(), restore);
    });
  }

  class FrameFormat extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      var self = this;
      this.addEventListener('click', function (event) {
        var button = event.target.closest('[data-format]');
        if (!button || button.getAttribute('aria-pressed') === 'true') return;
        self.choose(button);
      });
    }

    choose(button) {
      var picker = this.closest('variant-picker');
      var state = frameState(picker);
      if (!state) return;
      var pair = formatRadios(picker, state, button.dataset.format, readMemory());
      if (!pair) return;

      // Pressed at once; the server's picker confirms it a moment later.
      this.querySelectorAll('[data-format]').forEach(function (other) {
        other.setAttribute('aria-pressed', String(other === button));
      });
      commit(pair);

      // The preview on the front shot's slide (the second one since
      // 2026-11-03) shows the new format.
      var gallery = document.getElementById('MediaGallery-' + this.dataset.sectionId);
      var preview = gallery && gallery.querySelector('[data-pdp-gallery-track] lt-frame-preview');
      var slide = preview && preview.closest('[data-index]');
      if (slide && typeof gallery.goTo === 'function') {
        gallery.goTo(Number(slide.dataset.index));
      }
    }
  }

  customElements.define('lt-frame-format', FrameFormat);
})();
